/**
 * Deployed dev build (`npm run build:dev` → `ng build --configuration=development`).
 * Activated via angular.json fileReplacement that swaps `environment.ts`
 * for this file when building for the dev environment.
 */
export const environment = {
  production: false,
  apiUrl: 'https://dev-apitrustbanking.normaxcapital.com/api/v1',
  appName: 'Normax Admin',
  allowedStorageOrigins: [
    'https://normaxcapital-normax-trust-banking-backend-dev-853452245550.s3.us-east-1.amazonaws.com',
  ] as string[],
  telemetry: {
    enabled: true,
    collectorUrl:
      'https://faro-collector-prod-ap-south-1.grafana.net/collect/7b1cc453ba477525b516b46431a7173e',
    environment: 'development',
  },
};
